import { Inject } from '../Application';
import { Constants, ContentType, ErrorCode, Events } from '../Contract';
import { NetworkException } from '../System';
import { RequestConfig } from '.';
var HttpServer = (function () {
    function HttpServer(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject || Inject.Instance;
        this.library = this.inject.resolve(Constants.Library);
        this.event = this.inject.resolve(Constants.EventAggregator);
    }
    HttpServer.prototype.get = function (url, params, callback) {
        var _this = this;
        var request = this.library.query.get(url, params);
        request.done(function (result) { return _this.ExecuteResponse(result, callback); });
        request.fail(this.failedResponse(callback));
    };
    HttpServer.prototype.post = function (url, data, callback, config) {
        var _this = this;
        var request = this.sendRequest(url, data, config);
        request.always(function () {
            _this.event.publish(Events.ActionComplete);
        });
        request.done(function (response) {
            if (callback) {
                callback(response);
            }
        });
        request.fail(this.failedResponse(callback));
    };
    HttpServer.prototype.failedResponse = function (callback) {
        var _this = this;
        return function (response) {
            if (response.status) {
                _this.event.publish(Events.Error, new NetworkException(response.responseText, response.status));
            }
            if (callback) {
                callback(response);
            }
        };
    };
    HttpServer.prototype.ExecuteResponse = function (response, callback) {
        this.validateResponse(response);
        if (callback) {
            callback(response);
        }
    };
    HttpServer.prototype.validateResponse = function (response) {
        if (response.ErrorOcurred) {
            var message = "".concat(response.ExMessage, "<pre>").concat(response.ExStackTrace, "<pre>");
            throw new NetworkException(message, ErrorCode.ServerError);
        }
    };
    HttpServer.prototype.sendRequest = function (url, data, config) {
        config = config || new RequestConfig();
        config.contentType = config.contentType || ContentType.applicationJson;
        if (config.contentType && config.contentType === ContentType.multipartFormdata) {
            return this.processFormData(url, data);
        }
        else {
            return this.processDefault(url, data, config);
        }
    };
    HttpServer.prototype.processFormData = function (url, data) {
        var _this = this;
        return this.library.query.ajax(url, {
            beforeSend: function () {
                _this.event.publish(Events.ActionSending);
            },
            contentType: false,
            data: data,
            headers: { WM: true },
            processData: false,
            type: 'POST'
        });
    };
    HttpServer.prototype.processDefault = function (url, data, config) {
        var _this = this;
        config.headers.WM = 'true';
        return this.library.query.ajax(url, {
            beforeSend: function () {
                _this.event.publish(Events.ActionSending);
            },
            contentType: config.contentType,
            data: data,
            dataType: 'json',
            headers: config.headers,
            type: 'POST'
        });
    };
    return HttpServer;
}());
export { HttpServer };
